<div class="container" *ngIf="state$ | async as s">
  <h1>Workspace usage</h1>
  <p class="subtitle">
    Plan, optimized-run counters, and feature flags for <strong>this org</strong>. For per-environment token and savings
    rollups from the <strong>in-app SDK</strong> (API key), open
    <a routerLink="/projects">Projects</a> → a project. For <strong>cloud-synced session</strong> rollups (OpenClaw /
    Local Companion, etc.), see <a routerLink="/analytics">Session analytics</a>.
  </p>
  <p class="subtitle subtle">
    License keys, invoices, and checkout: <a routerLink="/billing">Plan &amp; Billing</a>.
  </p>

  <div *ngIf="s.loading && !s.entitlement" class="loading">
    <p>Loading usage…</p>
  </div>

  <div *ngIf="!s.loading && !s.entitlement" class="error-box">
    <p>Could not load usage for this workspace.</p>
  </div>

  <div class="usage-grid" *ngIf="s.entitlement">
    <section class="card">
      <h2>Plan</h2>
      <p class="plan-line">
        <span class="plan-name">{{ planLabel(s) }}</span>
        <span class="hint" *ngIf="s.billingStatus?.['subscription_active']"> — subscription active</span>
      </p>
      <p class="hint" *ngIf="s.billingStatus && (s.billingStatus['org_platform_exempt'] || s.billingStatus['platform_billing_exempt'])">
        This workspace has full platform access (billing exempt).
      </p>
    </section>

    <section class="card" *ngIf="s.entitlement['optimizedRunsLimit'] !== null">
      <h2>Optimized runs (mode = on)</h2>
      <div class="usage-bar-wrapper">
        <div class="usage-bar">
          <div
            class="usage-bar-fill"
            [style.width.%]="runUsagePercent(s)"
            [class.warn]="runUsagePercent(s) > 80"
            [class.critical]="runUsagePercent(s) >= 100"
          ></div>
        </div>
        <span class="usage-text">
          {{ s.entitlement['optimizedRunsUsed'] }} / {{ s.entitlement['optimizedRunsLimit'] }}
        </span>
      </div>
      <p class="usage-note">Observe mode and pass-through do not count toward this limit.</p>
    </section>

    <section class="card" *ngIf="s.entitlement['optimizedRunsLimit'] === null">
      <h2>Optimized runs</h2>
      <p class="unlimited">No fixed run cap on this workspace.</p>
    </section>

    <section class="card">
      <h2>Feature access</h2>
      <ul class="feature-list">
        <li [class.on]="s.entitlement['sdkEnabled']">SDK integration</li>
        <li [class.on]="s.entitlement['desktopAppEnabled']">Desktop / companion</li>
        <li [class.on]="s.entitlement['cloudAnalyticsEnabled']">Cloud analytics sync</li>
      </ul>
    </section>

    <section class="card upgrade-card" *ngIf="showFreeTierUpgrade(s)">
      <h2>Upgrade from Free Tier</h2>
      <p class="upgrade-lede" *ngIf="showStripeSelfServeCheckout">
        Pick Developer Pro or Team Pro (each uses its own Stripe price on the server), then continue to checkout.
      </p>
      <p class="upgrade-lede" *ngIf="!showStripeSelfServeCheckout">
        Self-serve checkout is paused while we validate the in-app SDK. You can still review tiers on Plan &amp; Billing.
      </p>
      <div class="checkout-plan-grid" *ngIf="showStripeSelfServeCheckout" role="radiogroup" aria-label="Self-serve plan">
        <label
          *ngFor="let p of selfServePlanCards"
          class="checkout-plan-option"
          [class.checkout-plan-option--disabled]="!isCheckoutPlanSelectable(p.id, s)"
          [class.checkout-plan-option--active]="selectedCheckoutPlan === p.id"
        >
          <input
            type="radio"
            name="usage_saas_checkout_plan"
            [value]="p.id"
            [(ngModel)]="selectedCheckoutPlan"
            [disabled]="!isCheckoutPlanSelectable(p.id, s)"
          />
          <span class="checkout-plan-option__body">
            <span class="checkout-plan-option__name">{{ p.name }}</span>
            <span class="checkout-plan-option__price">{{ p.price }}</span>
          </span>
        </label>
      </div>
      <div class="upgrade-actions">
        <button
          type="button"
          class="btn-primary"
          *ngIf="showStripeSelfServeCheckout"
          (click)="upgrade()"
          [disabled]="upgrading"
        >
          {{ upgrading ? 'Redirecting…' : 'Continue to secure checkout' }}
        </button>
        <a routerLink="/billing" class="btn-secondary">Compare plans on Plan &amp; Billing</a>
      </div>
      <p class="error" *ngIf="error">{{ error }}</p>
    </section>
  </div>
</div>
